import { ROUTE_PATH, SELECT_DATA } from "common/constants/sm-constants";
import { GridMetaModel, Headers, SmBtnMetaModel, SmMetaInputModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class AssignementAcceptedGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Assignment Accepted',
      ROUTE_PATH.assignment_accepted,
      ROUTE_PATH.trainersGrid,
      true,
      false,
      8,
      false,
      false,
      ['student_name'],
      false,
      [],
      {
        isDownloadExcel: true,
        excelFileName: 'Assignment-Accepted.xlsx',
        btnLabel: 'Download Selected',
        headers: [{ key: 'studentName', value: 'student_name' },
        { key: 'attended', value: 'attended_flag' },
        { key: 'score', value: 'score' },
        { key: 'assignement', value: 'student_ratings' },
        { key: 'feedbackToAdmin', value: 'student_feedback' },
        { key: 'feedbackFromStudent', value: 'trainer_feedback_to_student' },
        { key: 'feedbackToStudent', value: 'trainer_feedback_to_student' },],
      },
      false,
      null,
      false,
      true,
      false,
      null,
      null,
      false,
      null,
      {
        isPreview: false,
        isPreviewType: 'VIDEO',
        isEnvUrl: false,
        linkKey: ['filePath'],
        previewName: '',
      },
      {
        isTabSwitch: false,
        label: '',
        isChecked: false,
      },
      false,
      false,
      true,
      [],
      true,
      { isExtraActions: true, btnLabel: 'Notify Students' },
      null
    );
  }

  override initProperties() {
    const dataInfo = super.initProperties();
    const buttons = {
      evaluateAll: new SmBtnMetaModel('Evaluate All', '', true, false, true, true),
      isFormControl: false
    };
    const selectOptions = new SmMetaSelectModel(
      'selectOptions',
      'selectOptions',
      'ng-select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      SELECT_DATA,
      'name',
      'id'
    );


    const search = new SmMetaInputModel(
      'search',
      'search',
      'input',
      false,
      'col-3',
      1,
      3,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    
    const selectedFlagIds: any = [];
    const downloadAssigmentfileList: any = [];
    const studentDetails: any[] = [];
    const save = new SmBtnMetaModel('Save', 'primary', true, false, true, false);

      dataInfo.save = save,
      dataInfo.buttons = buttons,
      dataInfo.selectOptions = selectOptions,
      dataInfo.search = search,
      dataInfo.downloadAssigmentfileList = downloadAssigmentfileList,
      dataInfo.studentDetails = studentDetails,
      dataInfo.selectedFlagIds = selectedFlagIds
    return dataInfo
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    // const checkbox = new Headers('', '', false, false, 'checkbox');
    const studentName = new Headers(
      'Student Name',
      'student_name',
      false,
      true,
      'text'
    );
    const attended = new Headers(
      'Attended (Y/N)',
      'attended_flag',
      false,
      true,
      'toggle'
    );
    const score = new Headers('Score', 'score', false, true, 'text');
    const assignement = new Headers(
      'Assignment',
      'student_file_submit',
      false,
      true,
      'link',
      '0',
      {
        isColumnNavigation: false,
        navigationUrl: '',
        navigateOperationType: null,
        navigateTransferData: null,
      },
      ['file_url_path', 'student_file_submit']
    );
    const accepted = new Headers(
      'Accepted',
      'accepted_flag',
      false,
      true,
      'toggle'
    );
    const rating = new Headers(
      'Rating from Student',
      'student_ratings',
      false,
      true,
      'rating'
    );
    const feedbackToAdmin = new Headers(
      'Feedback from Admin',
      'student_feedback',
      false,
      true,
      'text'
    );
    const feedbackFromStudent = new Headers(
      'Feedback from Student',
      'trainer_feedback_to_student',
      false,
      true,
      'text'
    );
    const feedbackToStudent = new Headers(
      'Feedback To Student',
      'trainer_feedback_to_student',
      false,
      true,
      'text'
    );
    // headers.push(checkbox);
    headers.push(studentName);
    headers.push(attended);
    headers.push(score);
    headers.push(assignement);
    headers.push(accepted);
    headers.push(rating);
    headers.push(feedbackFromStudent);
    headers.push(feedbackToStudent);
    headers.push(feedbackToAdmin);

    return headers;
  }
}